import ReviewManager from "@/components/reviews/ReviewManager";

function ReviewPage() {
  return <ReviewManager />;
}

export default ReviewPage;